<template>
  <div>

    <div v-if="(teamMembers ?? []).length > 0" class="etx-container Container" :class="paragraphClassList">
      <div class="etx-center Center">

        <div class="etx-flex Flex">
          <div class="etx-flex__item Flex__item mob-m:c-9 mob-l:c-12">

            <div :class="{ Tabs: (teamMembers ?? []).length > 1 }">

              <div v-if="(teamMembers ?? []).length > 1" class="Tabs__header" :class="entranceClassList">

                <div v-for="(teamMemberGroup, index) in teamMembers" :key="teamMemberGroup.id"
                  class="Tabs__header__item" :class="{ active: activeTab === index }" @click="activeTab = index"
                  :data-tab-id="'team-members-tab-' + teamMemberGroup.id">
                  <span>{{ teamMemberGroup.label }}</span>
                </div>

              </div>

              <div :class="{ Tabs__content: (teamMembers ?? []).length > 1 }">

                <div v-for="(teamMemberGroup, index) in teamMembers" :key="teamMemberGroup.id" :class="{
                    Tabs__content__item: (teamMembers ?? []).length > 1,
                    active: (teamMembers ?? []).length > 1 && activeTab === index
                  }" :data-tab-id="'team-members-tab-' + teamMemberGroup.id">

                  <div class="etx-flex Flex mob-l:c-2 tab-l:c-3 gh-200 gv-300">

                    <div v-for="teamMember in teamMemberGroup.members" class="etx-flex__item Flex__item"
                      :key="teamMember.id">


                      <div class="etx-card Card" :class="entranceClassList">

                        <div class="etx-card__item Card__item ph-0 pv-0">

                          <div class="etx-media Media">
                            <MediaImage :media="teamMember?.image" imageStyle="image_1_1" />
                          </div>

                        </div>

                        <div class="etx-card__item Card__item ph-0 pt-75 pb-0">

                          <div class="etx-text Text">
                            <p class="font-size-larger font-weight-bold">{{ teamMember.name }} <span
                                class="font-uppercase">{{ teamMember.surname }}</span></p>
                            <p class="font-weight-bold font-color-primary">{{ teamMember?.jobTitle?.label }}</p>
                          </div>

                          <div class="ContactInfoWithPopup" v-if="teamMember?.shortDescription || teamMember?.accordions.length > 0">
                            <div class="etx-button-list ButtonList a-right OpenContactInfo"
                              :data-id="'team-member-' + teamMemberGroup.id + '-' + teamMember.id">
                              <a class="etx-button Button minimal" title="">
                                <div class="etx-button__icon Button__icon">
                                  <i class="fal fa-arrow-up-from-line"></i>
                                </div>
                              </a>
                            </div>
                          </div>

                          <div v-if="teamMember.phone1 || teamMember.email1"
                            class="etx-accordion-list AccordionList AccordionList__ContactInfo">
                            <div class="etx-accordion Accordion">
                              <div class="etx-accordion__header Accordion__header">

                                <div class="etx-accordion__header__button Accordion__header__button"
                                  data-accordion-clickable>
                                  <i class="far fa-plus font-color-secondary"></i>
                                </div>
                              </div>
                              <div class="etx-accordion__content Accordion__content">
                                <div class="etx-item-list ItemList ">

                                  <a v-if="teamMember.phone1" class="etx-item Item" :href="`tel:${ teamMember.phone1 }`"
                                    title="">
                                    <div class="etx-item__icon Item__icon"><i class="fal fa-phone"></i></div>
                                    <div class="etx-item__text Item__text font-weight-bold">
                                      <span>{{
                                        formatSwissPhoneNumber(teamMember.phone1)
                                      }}</span></div>
                                  </a>

                                  <a v-if="teamMember.email1" class="etx-item Item"
                                    :href="`mailto:${ teamMember.email1 }`" title="">
                                    <div class="etx-item__icon Item__icon"><i class="fal fa-envelope"></i></div>
                                    <div class="etx-item__text Item__text font-weight-bold"><span>{{ teamMember.email1
                                        }}</span></div>
                                  </a>

                                </div>
                              </div>
                            </div>
                          </div>

                        </div>

                      </div>

                      <div class="Popup PopupContact"
                        :data-id="'team-member-' + teamMemberGroup.id + '-' + teamMember.id">

                        <div class="Popup__background"></div>

                        <div class="Popup__close PopupContact__close">
                          <i class="fa-light fa-times"></i>
                        </div>

                        <div class="PopupContact__content" :class="entranceClassList">
                          <div class="etx-flex Flex gh-0 gv-0 av-stretch a-center">
                            <div class="etx-flex__item Flex__item tab-s:c-10 bg-secondary TriangleContent"
                              data-angle-position="top-right" data-angle-color="orange">
                              <div class="etx-flex Flex__info av-stretch gv-0 gh-50 tab-s:gh-100 tab-l:gh-200">
                                <div class="etx-flex__item FlexItem__person c-12 tab-m:c-5">
                                  <div class="etx-card Card bg-secondary">

                                    <div
                                      class="etx-card__item Card__item tab-m:ph-150 tab-l:ph-200 tab-m:pv-150 tab-l:pv-200 shrink-1">
                                      <div class="etx-text Text">
                                        <p class="font-h3 font-color-primary">{{ teamMember.name }} {{
                                          teamMember.surname
                                          }}</p>

                                        <p>{{ teamMember?.jobTitle?.label }}</p>
                                        <p class="font-color-medium">
                                          {{ teamMember?.birthYear }}
                                          <span v-if="teamMember?.birthYear && teamMember?.nationality"> | </span>
                                          {{ teamMember?.nationality }}
                                        </p>
                                      </div>
                                    </div>
                                    <div class="etx-media Media">
                                      <MediaImage :media="teamMember?.image" imageStyle="image_1_1" />
                                    </div>
                                    <div class="etx-spacer h-0 tab-s:h-25 tab-m:h-50"></div>
                                  </div>

                                </div>
                                <div class="etx-flex__item FlexItem__about c-12 tab-m:c-7">
                                  <div class="etx-card Card bg-secondary">
                                    <div
                                      class="etx-card__item Card__item tab-m:ph-150 tab-l:ph-200 tab-m:pv-150 tab-l:pv-200 grow-1">

                                      <div class="etx-text Text" v-if="teamMember?.shortDescription">
                                        <HelperHtmlRenderer :htmlContent="teamMember?.shortDescription"/>
                                      </div>

                                      <div class="etx-accordion-list AccordionList" v-if="teamMember?.accordions.length > 0">

                                        <div class="etx-accordion Accordion" v-for="accordion in teamMember.accordions">

                                          <div class="etx-accordion__header Accordion__header">

                                            <div class="etx-accordion__header__title Accordion__header__title"
                                              data-accordion-clickable="">
                                              {{ accordion?.heading }}
                                            </div>

                                            <div class="etx-accordion__header__button Accordion__header__button"
                                              data-accordion-clickable="">
                                              <i class="far fa-plus"></i>
                                            </div>

                                          </div>

                                          <div class="etx-accordion__content Accordion__content">

                                            <div class="etx-text Text">
                                              <HelperHtmlRenderer :htmlContent="accordion?.text"/>
                                            </div>

                                          </div>

                                        </div>
                                      </div>


                                      <div class="etx-button-list ButtonList a-right" v-if ="teamMember?.buttons.length > 0">

                                        <a v-for="button in teamMember.buttons" class="etx-button Button minimal" :href="button?.domainUri.path || button?.uri.path" :title="button?.title" target="_blank">
                                          <div class="etx-button__text Button__text">
                                            <span>{{ button?.title }}</span>
                                          </div>
                                          <div class="etx-button__icon Button__icon">
                                            <i class="far fa-long-arrow-right"></i>
                                          </div>
                                        </a>

                                      </div>

                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>

                      </div>



                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>
        </div>

      </div>
    </div>

    <div class="etx-container Container pt-50 pb-50" :class="paragraphClassList" v-else-if="isEditing">
      <div class="etx-center Center">
        <p class="editor-placeholder">
          Derzeit sind keine Mitarbeitende für die ausgewählten Kategorien verfügbar.
        </p>
      </div>
    </div>

  </div>
</template>

<script lang="ts" setup>

const props = defineProps<{
  teamCategories: Array<{
    id: string,
    label: string
  }>,
  teamMembers: Array<{
    id: string,
    name: string,
    surname: string,
    jobTitle: {
      label: string,
      id: string
    },
    phone1: string,
    email1: string,
    image: {},
    categories: Array<{
      id: string,
      label: string
    }>,
    birthYear?: string,
    nationality?: string,
    shortDescription?: string,
    accordions?: Array<{
      heading?: string,
      text?: string,
    }>,
    buttons?: Array<{
      title?: string,
      uri: {
        path: string
      }
    }>,
  }>
}>()

// Fetch the team members, with matching query key (for caching).
const categories: string[] = props.teamCategories.map((category) => category.id);
const queryKey = `teamMembers-${categories.join('-')}`;
const { data: teamMembers = [] } = await useAsyncData(queryKey, async () => {
  return await useGraphqlQuery('teamMembers', { 'categories': categories }).then((v) => {
    const results = v.data?.entityQuery?.items ?? []
    const sortedResults = sortTeamMembersNull(results)
    return groupItemsByCategory(sortedResults, categories)
  })
})

// Helper function grouping the results by terms, with labels and filtered by
// the available categories from the paragraphs.
function groupItemsByCategory(items: any[], availableCategories: string[]) {
  const grouped: { [key: string]: { label: string, members: any[] } } = {};
  items.forEach(item => {
    item.categories.forEach((category: any) => {
      if (availableCategories.includes(category.id)) {
        if (!grouped[category.id]) {
          grouped[category.id] = {
            label: category.label,
            members: []
          };
        }
        grouped[category.id].members.push(item);
      }
    });
  });

  return Object.keys(grouped).map(key => ({
    id: key,
    label: grouped[key].label,
    members: grouped[key].members
  }));
}

const activeTab = ref(0);

const { options, isEditing } = defineBlokkli({
  bundle: 'team_listing_categories_popup',
  globalOptions: ['spacingTop', 'spacingBottom', 'backgroundColor'],
})

const paragraphClassList = computed(() => {

  const classList = []

  if (options.value.spacingTop) {
    classList.push(options.value.spacingTop)
  }

  if (options.value.spacingBottom) {
    classList.push(options.value.spacingBottom)
  }

  if (options.value.backgroundColor !== 'white') {
    classList.push(options.value.backgroundColor)
  }

  return classList
})

const entranceClassList = computed(() => {
  const classList = []
  if (!isEditing) {
    classList.push('will-appear', 'move-up')
  }
  return classList
})

</script>
